import axios from 'axios'

export default class Unimed {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/unimed`
    this.urlAbas = `${url}/api/unimed/versoes/mostrarAbaMandatos`
    this.urlConsulta = `${url}/api/unimed/consulta`
    this.urlTags = `${url}/api/unimed/tags`
    this.urlCodigo = `${url}/api/unimed/codigo`
    this.urlNovaUnimed = `${url}/api/unimed/nova`
    this.tokenBearer = tokenBearer
  }

  getVerificaMudanca () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/verificarEdicao`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getParticipacoes () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/participacoesSocietarias`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  putCancelEdit () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.url}/cancelarEdicao`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  putStartEdit (id) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.url}/iniciarEdicao/${id}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  putFinishEdit (ignorarDocComprobatorio = false) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.url}/finalizarEdicao?ignorarDocComprobatorio=${ignorarDocComprobatorio}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getAbas (id) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlAbas}/${id}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseGet = await axios(options)
        resolve(responseGet)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getConsulta (idUnimed) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlConsulta}?unimedId=${idUnimed}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseGet = await axios(options)
        resolve(responseGet)
      } catch (err) {
        reject(err)
      }
    })
  }

  getTags (id) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlTags}/${id}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseGet = await axios(options)
        resolve(responseGet)
      } catch (err) {
        reject(err)
      }
    })
  }

  putTags (id, tag) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.urlTags}/${id}?tag=${tag}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responsePut = await axios(options)
        resolve(responsePut)
      } catch (err) {
        reject(err)
      }
    })
  }

  deleteTags (id, data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url: `${this.urlTags}/${id}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let responseDelete = await axios(options)
        resolve(responseDelete)
      } catch (err) {
        reject(err)
      }
    })
  }

  verifyCodigo (codigo) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlCodigo}/${codigo}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseGet = await axios(options)
        resolve(responseGet)
      } catch (err) {
        reject(err)
      }
    })
  }

  novaUnimed (codigo) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url: `${this.urlNovaUnimed}/${codigo}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responsePost = await axios(options)
        resolve(responsePost)
      } catch (err) {
        reject(err)
      }
    })
  }
}
